import Login from "./Login/index.vue";
import ResetPWD from "./Login/ResetPWD.vue";

export default [{
  path: '/login',
  component: Login,
}, {
  path: '/resetPWD',
  component: ResetPWD,
}]